var _defs, _polyline, _rect, _rect2, _path, _polyline2, _line, _line2, _line3, _path2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _circle, _path10, _path11, _rect5, _path12, _polygon, _polygon2, _line4, _line5, _line6, _line7, _line8, _rect6, _rect7, _polygon3, _path13, _polyline3, _path14, _path15, _line9, _line10, _line11, _line12, _line13, _line14, _rect8, _circle2, _line15, _rect9, _circle3, _line16, _rect10, _circle4, _line17, _rect11, _circle5, _line18, _rect12, _circle6, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerPic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-15,.cls-16,.cls-17,.cls-5{fill:none;}.cls-1{stroke:#dfdfdf;stroke-miterlimit:10;}.cls-1,.cls-14,.cls-16,.cls-5{stroke-width:4px;}.cls-2{fill:#f3f3f3;}.cls-3{fill:#dfdfdf;}.cls-4{fill:#56cad8;}.cls-5{stroke:#ed7562;}.cls-14,.cls-15,.cls-16,.cls-17,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-6{fill:#ed7562;}.cls-7{fill:#de8e68;}.cls-8{fill:#d37c59;}.cls-9{fill:#fcc486;}.cls-10{fill:#fed385;}.cls-11{fill:#fed892;}.cls-12{fill:#fd8369;}.cls-13{fill:#74d5de;}.cls-14{stroke:#fd8369;}.cls-15{stroke:#8bdde4;stroke-width:3px;}.cls-16,.cls-17{stroke:#f3f3f3;}.cls-17{stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "205.45 483.05 176 483.05 176 722.67"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.28,
    y: 453.49,
    width: 262.42,
    height: 505.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 200.96,
    y: 453.49,
    width: 61.04,
    height: 505.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.94,974c-59.23,0-160.29-90.39-160.29-165.46,0-5.71,2.71-16.49,8.69-16.49C143.67,792,262.94,888.37,262.94,974Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "655.57 316.71 655.57 646.56 674.5 646.56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 967.87,
    y1: 1008.54,
    x2: 902.89,
    y2: 899.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 996.05,
    y1: 1008.54,
    x2: 931.07,
    y2: 899.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 788.62,
    y1: 1008.54,
    x2: 853.59,
    y2: 899.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M938,668.8h96.07L969.55,902.63H805.87V894.3H927.26Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 778.15,
    y: 1001.4,
    width: 18.43,
    height: 16.47,
    transform: "translate(-145.82 133.01) rotate(-8.84)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 666.64,
    y: 983.46,
    width: 18.43,
    height: 16.47,
    transform: "translate(649.05 -208.11) rotate(33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M748.58,822.26c-13.45,0-80.58,156.29-80.58,162s14.57,12.19,16.72,12.19c3.35-3.11,67.61-96,74.3-102.48S748.58,822.26,748.58,822.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M855.4,707.49c-4.42,1.39-26,19.88-29.77,42.09-3.84-.46-26.88-1.42-36.48-1.81-3.14-4.89-9.75-8.28-17.42-8.28-10.69,0-19.36,6.57-19.36,14.67,0,.18,0,.35,0,.53h38.65c0-.18,0-.35,0-.53a11.65,11.65,0,0,0-1.6-5.82L823,753.69l39.89,4.15L867,723Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M888.52,682.74c0-2.81-7-6-12.14-6-13.72,0-36.93,25-36.93,28.14S856.16,722,869,722.84,888.52,682.74,888.52,682.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M922.6,662.7c77.55,0,59.83,175.19,50,182.59s-96,8.08-101.61.68S830.57,662.7,922.6,662.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M936.23,629.19h-31v41.53c0,6.59,31,6.64,31,0Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 914.86,
    cy: 608.69,
    rx: 45.55,
    ry: 30.64,
    transform: "translate(169.64 1416.23) rotate(-80.94)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M987.5,541.5c15,0,30,8,49,8,15,0,29-6,47-6,32,0,42,21,42,34,0,33-27,46-47,46-32,0-36-22-74-22-37,0-32-30-40-30-4,0-6.5.5-8,2s-9-4-9-6S957.5,541.5,987.5,541.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M920.5,552.5c-35.37,0-42.77,26.91-42.77,34.68s4.91,13.53,7.42,13.72c1.56-9.29,9-22.11,9.35-22.4,2,2,9.41,8.42,17,9a37.69,37.69,0,0,1,17.85,5.56,19.09,19.09,0,0,0,2.86,7.24,17.38,17.38,0,0,0,8.78,7.15,21.64,21.64,0,0,1,1.51,7c0,10.68-1,15-2,18,16.3,0,24-16.79,24-38C964.5,559.53,933.6,552.5,920.5,552.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 942.45,
    cy: 614.66,
    r: 8.64
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M913.5,727.37c-3.49.84-17.48,9.51-25.87,24.47-8.25-1.54-41.81-9.93-71.6-9.93-2.8,0-10.07-2.3-13-2.3-17.47,0-21.12,9.44-21.12,12.23s.6,2.87,1.14,2.87c60,0,75.09,25.31,108.84,25.31,10.92,0,33.43-7.91,47-28.17C934.13,735.71,913.5,727.37,913.5,727.37Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M972.48,693.27c18.74,18.19-28.65,68.54-36.25,67.8s-35-29.59-35.26-38.36S954.37,675.68,972.48,693.27Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 587.77,
    y: 756.95,
    width: 423.23,
    height: 13.66
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M972.43,854c0-4.3.75-9.28-1.93-10.39-63.62-26.23-156.76-29.63-171.11-29.63s-56.31,1.46-56.31,13.47c0,43.38,24.17,176.93,29.08,181.92,2.33,2.35,22.65.78,25.18-1.76-.17-11,6.22-121.49.39-134.87,53.47,19.6,114.19,28.88,130.19,28.88C974.29,901.57,972.43,859.1,972.43,854Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "680.52 1001.56 664.38 990.8 620.94 981.7 616.81 988.52 668 1020.17 680.52 1001.56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "799.23 1012.08 780.08 1015.09 741.95 1037.81 743.53 1045.64 802.63 1034.26 799.23 1012.08"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 988.26,
    y1: 974.33,
    x2: 988.26,
    y2: 766.79
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 636.61,
    y1: 974.33,
    x2: 636.61,
    y2: 766.79
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 958.54,
    y1: 1015.92,
    x2: 958.54,
    y2: 766.79
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 605.21,
    y1: 1015.92,
    x2: 605.21,
    y2: 766.79
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 817.53,
    y1: 1008.54,
    x2: 882.5,
    y2: 899.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 743.08,
    y: 754.44,
    width: 70.27,
    height: 2.51
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 665.13,
    y: 590.85,
    width: 153.42,
    height: 111.41
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "720.29 681.31 699.13 756.95 736.22 756.95 756.76 681.31 720.29 681.31"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M750.19,322.09a44.73,44.73,0,0,0-47.45-73.68,62,62,0,0,0-109,9.67,44.73,44.73,0,0,0-55.41,64Z"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "639.95 313.62 639.95 385.34 419.88 385.34 419.88 453.49"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M296.48,1015.92c5.85,0,17.25-19.82,17.25-58.26,0-28.11-19.7-46.29-25.55-74.14-9-42.71-53.57-168.17-123.16-168.17-8,0-18.74,16.81-18.74,51.44,0,42,40.68,85.49,40.68,94.51C187,964.29,277.83,1015.92,296.48,1015.92Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M296.93,1015.92c0-5.63-8.14-43.4-12.37-52.84s-20.84-56.65-23.44-69.68-50.79-140.32-96.05-172.56"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 276.16,
    y1: 940.85,
    x2: 200.24,
    y2: 925.39
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 279.98,
    y1: 951.4,
    x2: 210.45,
    y2: 945.61
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 258.1,
    y1: 883.56,
    x2: 187.53,
    y2: 862.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.82,
    y1: 906.95,
    x2: 286.36,
    y2: 891.29
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 224.04,
    y1: 804.06,
    x2: 245.32,
    y2: 779.93
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 217.39,
    y1: 791.21,
    x2: 235.5,
    y2: 766.64
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.02,
    y: 485.46,
    width: 218.93,
    height: 42.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 486.23,
    cy: 501.26,
    r: 7.4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.62,
    y1: 501.26,
    x2: 472.6,
    y2: 501.26
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.02,
    y: 556.8,
    width: 218.93,
    height: 42.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 486.23,
    cy: 572.6,
    r: 7.4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.62,
    y1: 572.6,
    x2: 472.6,
    y2: 572.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.02,
    y: 628.13,
    width: 218.93,
    height: 42.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 486.23,
    cy: 643.93,
    r: 7.4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.62,
    y1: 643.93,
    x2: 472.6,
    y2: 643.93
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.02,
    y: 699.47,
    width: 218.93,
    height: 42.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 486.23,
    cy: 715.27,
    r: 7.4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.62,
    y1: 715.27,
    x2: 472.6,
    y2: 715.27
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.02,
    y: 770.8,
    width: 218.93,
    height: 42.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 486.23,
    cy: 786.61,
    r: 7.4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.62,
    y1: 786.61,
    x2: 472.6,
    y2: 786.61
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 515.82,
    x2: 247.9,
    y2: 515.82
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 524.32,
    x2: 247.9,
    y2: 524.32
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 573.65,
    x2: 247.9,
    y2: 573.65
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 582.15,
    x2: 247.9,
    y2: 582.15
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 643.93,
    x2: 247.9,
    y2: 643.93
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 652.44,
    x2: 247.9,
    y2: 652.44
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 711.93,
    x2: 247.9,
    y2: 711.93
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 215.06,
    y1: 720.44,
    x2: 247.9,
    y2: 720.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerPic1);
export default __webpack_public_path__ + "static/media/server_pic_1.b0117ec72130f811264be49bcb7f19ed.svg";
export { ForwardRef as ReactComponent };